import { css } from "@emotion/css";
import useTheme from "@common/hooks/useTheme";

const useStyles = () => {
  const theme = useTheme();

  const page = css`
    padding: 0;
  `;

  const rightAlignColumns = css`
    .oneTimeRevenueCol,
    .recurringRevenueCol,
    .totalValueCol,
    .oneTimeCostCol,
    .recurringCostCol,
    .profitCol,
    .marginCol {
      text-align: right;
    }

    .cellCol2 > div,
    .cellCol3 > div,
    .cellCol4 > div,
    .cellCol5 > div,
    .cellCol6 > div,
    .cellCol7 > div,
    .cellCol8 > div {
      justify-content: flex-end !important;
    }

    tbody[data-target=".multi-collapsetotal"] td {
      border-top: 3px solid ${theme.colors.navy["1"]};
    }

    tbody[data-target=".multi-collapsetotal"] {
      background-color: ${theme.colors.white} !important;
      border-top: none !important;
    }
  `;

  const totalRow = css`
    font-weight: 700;
  `;

  return {
    page,
    rightAlignColumns,
    totalRow,
  };
};

export default useStyles;
